import React, { useState, useRef, useEffect } from "react";
import { useButtonRegistry } from "../../ButtonRegistryContext";
import "./Options.scss";

const Options = (props:any) => {

   const eventref = useRef(null);
  const { registerButton } = useButtonRegistry();
   useEffect(() => {
      registerButton("findEvents", eventref);
  }, []);

  const options = [
  
    {
      text: "Need help finding events ",
      handler: props.actionProvider.handleFindEvents,
      id: 1,
    },
    {
      text: "Issue with notifications ",
      handler: props.actionProvider.handleNotifications,
      id: 2,
    },
    {
      text: "Issue with subscriptions ",
      handler: props.actionProvider.displaySubscriptions,
      id: 3,
    },

     {
      text: "Something else ",
      handler: props.actionProvider.handleMoreHelp,
      id: 4,
    }
    
  ];

  const [activeIndex, setActiveIndex] = useState(null);
  const [isDisabled, setIsDisabled] = useState(false);
  const [intitialClassName, setClassName] = useState("option-button");
  const [selectedOption, setSelectedOption] = useState("");

  const buttonsMarkup = options.map((option:any,index:any) => (
    <React.Fragment key={option.id}>
      <button 
        ref={option.id === 1 ? eventref : null} 
        onClick={()=>{
          // Prevent multiple clicks after a selection has been made
          if (isDisabled && activeIndex !== index) {
            return;
          }
          setIsDisabled(!isDisabled);
          setActiveIndex(index);
          setSelectedOption(option.text);
          option.handler();
          setClassName("option-inactive");
        }} 
        className={activeIndex === index?"change-buttons":intitialClassName} 
        aria-pressed={activeIndex === index}
        tabIndex={0} // Ensure all buttons remain in tab order
        role="button"
        aria-setsize={options.length}
        aria-posinset={index + 1}
      >
        {option.text}
      </button>
      <br/>
    </React.Fragment>
  ));

  return (
    <div className="options-container" role="listbox" aria-label="Help options">
      {buttonsMarkup}
      {selectedOption && (
        <div aria-live="polite" className="sr-only">
          Selected: {selectedOption}
        </div>
      )}
    </div>
  );
};

export default Options;
